import { useUserState } from '../_states/user';
import type { ModuleClaim } from '../_types/module-claim';
import type { RoleClaim } from '../_types/role-claim';

interface UseHasPermissionProps {
  module: ModuleClaim;
  roles: RoleClaim[];
}

export function useHasPermission({ module, roles = [] }: UseHasPermissionProps) {
  const getRole = useUserState((s) => s.getRole);
  const role = getRole({ module }) ?? ('' as RoleClaim);
  return roles.includes(role);
}
